import { createContext, useContext } from 'react'

export const TileRendererContext = createContext(null)

export function TileRendererProvider({ renderer, children }) {
  return (
    <TileRendererContext.Provider value={renderer}>
      {children}
    </TileRendererContext.Provider>
  )
}

export function useTileRenderer() {
  const renderTile = useContext(TileRendererContext)
  if (!renderTile) {
    throw new Error('useTileRenderer must be used within a TileRendererProvider')
  }
  return renderTile
}
